import { Card, CardActionArea, CardContent, Chip, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useFormatter } from '@omnea-app/fe-i18n/useFormatter'
import { generateRequestDetailRoute, RequestTabs } from '@omnea-app/fe-requests/requestRoutes'
import { SourcingEventRow } from './useRfxColumns'
import { useRfxStatusLabel } from './useRfxStatusLabel'

const RfxCard = ({ row }: { row: SourcingEventRow }) => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section' })
  const { formatDateString } = useFormatter()
  const rfxStatusLabel = useRfxStatusLabel()

  // We go to the overview rather than the RFx tab as the RFx tab isn't available on mobile
  const href = generateRequestDetailRoute(RequestTabs.OVERVIEW, row.requestId)
  return (
    <Card key={row.id}>
      <CardActionArea LinkComponent={Link} href={href}>
        <CardContent>
          <Stack gap={3}>
            <Stack sx={{ justifyContent: 'space-between', flexDirection: 'row' }} alignItems="center">
              <Chip label={rfxStatusLabel(row)} color={row.kind === 'AUCTION' ? 'info' : 'neutral'} />
              {row.deadlineType && row.dueDate && (
                <Typography variant="body-regular" color="text.muted">
                  {t('table.nextDeadlineValue', {
                    deadline: t(`table.deadline-types.${row.deadlineType}`),
                    date: formatDateString(row.dueDate, { format: 'short' }),
                  })}
                </Typography>
              )}
            </Stack>

            <Typography variant="body-medium">{row.requestName}</Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export const RfxMobileCards = ({ rows }: { rows: SourcingEventRow[] }) => {
  return (
    <Stack spacing={3}>
      {rows.map((row) => (
        <RfxCard key={row.id} row={row} />
      ))}
    </Stack>
  )
}
